import { call, put, takeLatest } from 'redux-saga/effects';
import { Companies } from 'services/api';
import {
  addEmployee,
  addEmployeeSuccess,
  addEmployeeFailure,
  getEmployees,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* addEmployeeSaga({ payload }) {
  try {
    const data = yield call(Companies.addUser, payload.companyId, {
      company: payload.values,
    });
    yield put(addEmployeeSuccess(data));
    yield put(getEmployees(payload.companyId));
    yield put(
      notificationActions.addNotification([
        { type: 'success', message: { code: 'manageEmployees.add' } },
      ])
    );
  } catch (e) {
    yield put(addEmployeeFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(addEmployee, addEmployeeSaga);
